import ProfileComponent from "../Components/Profile";

const WishlistPage = () => {
  return (
    <>
      <ProfileComponent name={"My Favorites"} />
    </>
  );
};

export default WishlistPage;
